"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Render = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _ = require("../../../");

var defaultAttrs = function defaultAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.Tools.applyDefaults({
    children: "Button Text",
    fontSize: 14,
    fontFamily: "Arial, Helvetica, sans-serif",
    backgroundColor: "#F15953",
    color: "#ffffff",
    paddingTop: 13,
    paddingRight: 16,
    paddingBottom: 13,
    paddingLeft: 16,
    borderSize: 0,
    borderColor: "",
    url: ""
  }, attrs);
};

var _default = {
  Render: _Render["default"],
  Form: _Form["default"],
  type: "Button",
  label: "Button",
  description: "Button component that can be used as a call to action.",
  // validation: Yup.object()
  defaultAttrs: defaultAttrs,
  generateContent: function generateContent() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        parent = _ref.parent;

    var content = [{
      id: _.Tools.generateUUID(),
      type: "Button",
      attrs: defaultAttrs(),
      content: []
    }];
    return [{
      id: _.Tools.generateUUID(),
      type: "Row",
      attrs: {
        allowChildren: false
      },
      content: content
    }];
  }
};
exports["default"] = _default;